import Vue from "vue";
import VueRouter from "vue-router";
import Layout from '@/layout'

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    component: Layout,
    redirect: '/home',
    children: [
      {
        path: 'home',
        name: 'home',
        component: () => import('@/views/HomeView'),
        meta: { title: '网站首页', hideFooter: true }
      },
      {
        path: 'about',
        name: 'about',
        component: () => import('@/views/About/About'),
        meta: { title: '了解追光' }
      },
      {
        path: 'application',
        name: 'application',
        component: () => import('@/views/Application/Application.vue'),
        meta: { title: '应用领域' }
      },
      {
        path: 'product',
        name: 'product',
        component: () => import('@/views/Product/Product.vue'),
        meta: { title: '产品中心' }
      },
      {
        path: 'productDetails',
        name: 'productDetails',
        component: () => import('@/views/Product/details.vue'),
        meta: { title: '产品中心' }
      },
      {
        path: 'news',
        name: 'news',
        component: () => import('@/views/News/News.vue'),
        meta: { title: '新闻中心' }
      },
      {
        path: 'newsDetails',
        name: 'newsDetails',
        component: () => import('@/views/News/details.vue'),
        meta: { title: '新闻中心' }
      },
      {
        path: 'service',
        name: 'service',
        component: () => import('@/views/Service/Service.vue'),
        meta: { title: '服务中心' }
      },
      {
        path: 'information',
        name: 'information',
        component: () => import('@/views/Information/Information.vue'),
        meta: { title: '资料下载' }
      },
      {
        path: 'contact',
        name: 'contact',
        component: () => import('@/views/Contact/Contact.vue'),
        meta: { title: '联系我们' }
      },
    ]
  }
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

const VueRouterPush = VueRouter.prototype.push

VueRouter.prototype.push = function push(to) {

  return VueRouterPush.call(this, to).catch(err => err)

}

export default router;
